import { render, staticRenderFns } from "./BriefButlerErrors.vue?vue&type=template&id=6499874c"
import script from "./BriefButlerErrors.vue?vue&type=script&lang=js"
export * from "./BriefButlerErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports